module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./THCloudWarehouseView.js"));
	}, "THCloudWarehouseView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=THCloudWarehouseView!./src/pages/Shop/Member/Personal/THCloudWarehouse/THCloudWarehouseView.js
// module id = 981
// module chunks = 431